import { getCookies } from "../Cookie/index.js";
import { Utils } from "../HTTP/index.js";
import { isObject, isString } from "../TypeChecking/index.js";
import { hasOwnProperty } from "../Utils/index.js";
const cookieNameRegex = /^(?:st_)?([^_]{2,5})_ut$/;
export function StandardUserIdRetriever() {
    const cookies = getCookies();
    let prodCookie = null;
    let stagCookie = null;
    for (const cname in cookies) {
        if (cname.match(cookieNameRegex)) {
            if (cname.startsWith("st_")) {
                stagCookie = extractUserIdFromUtCookie(cookies[cname].trim());
            }
            else
                prodCookie = extractUserIdFromUtCookie(cookies[cname].trim());
        }
    }
    return prodCookie && prodCookie != "" ? prodCookie : (stagCookie && stagCookie != "" ? stagCookie : null);
}
function extractUserIdFromUtCookie(s) {
    const parsed = Utils.unparam(s);
    if (isTokenAndUser(parsed)) {
        const sub = parsed.T.substring(0, 16);
        return sub.length >= 12 ? sub : null;
    }
    return null;
}
function isTokenAndUser(x) {
    return isObject(x) &&
        hasOwnProperty(x, 'T') &&
        isString(x['T']);
}
